import { PayloadAction } from "@reduxjs/toolkit";
import { PricingState } from "../pricingSlice";

export interface PendingPriceUpdate {
  contractFunnelId: string;
  contractIdentifier?: string;
  timeoutId?: NodeJS.Timeout;
}

export const priceUpdateReducers = {
  schedulePriceUpdate: (state: PricingState, action: PayloadAction<{
    id:string
  }>) => {
    const { id } = action.payload;
    state.pendingUpdates[id] = true;
  },

  clearPriceUpdate: (state: PricingState, action: PayloadAction<string>) => {
    const id = action.payload;
    delete state.pendingUpdates[id];
  },

  clearAllPriceUpdates: (state: PricingState) => {
    state.pendingUpdates = {};
  }
}
